function assetExists(asset) {
  // null represents a deleted asset
  return asset === null || asset;
}

export default function getAssetsFromMap(
assetMap, ids)
{
  if (!ids) {return Array.from(assetMap.values()).filter(assetExists);}

  return ids.map((assetId) => assetMap.get(assetId)).filter(assetExists);
}